import type { TwoColumnListComponent } from "../../types";

const LEFT_BG = "#0095DB";
const RIGHT_BG = "#EDF7FC";
const RIGHT_TEXT = "#005CA9";

/** Two-column list renderer with blue header and light content. */
export function TwoColumnListRenderer({ component }: { component: TwoColumnListComponent }) {
  const { items } = component.content;
  if (!items?.length) return null;
  return (
    <section className="mt-4 md:mt-6 overflow-hidden rounded-lg">
      <div className="flex flex-col">
        {items.map((item, idx) => (
          <div
            key={`${item.left}-${idx}`}
            className="grid grid-cols-[minmax(0,1fr)_minmax(0,2fr)] md:grid-cols-[minmax(180px,1fr)_minmax(0,2fr)]"
          >
            <div
              className="px-4 py-3 md:px-5 md:py-3.5 text-sm xl:text-base md:text-base text-left"
              style={{ backgroundColor: LEFT_BG, color: "white" }}
            >
              {item.left}
            </div>
            <div
              className="px-4 py-3 md:px-5 md:py-3.5 text-sm xl:text-base md:text-base text-left"
              style={{ backgroundColor: RIGHT_BG, color: RIGHT_TEXT }}
            >
              {item.right}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
